import { HttpClient } from 'api/HttpClient';
import { Lender } from 'enums/ApplicationsVariables';

import { ApplicationDto } from './ApplicationApi';

export interface AcceptOfferRequestDto {
  applicationId: string;
  loanAmount: number;
  term: number;
  lender: OfferLender;
}

export interface AcceptOfferResponseDto {
  isApplicationRejected: boolean;
}

export interface OffersRequestDto {
  applicationId: string;
  loanAmount: number;
}

export interface OffersResponseDto {
  cashToYou: number;
  loanOffers: OfferDto[];
  minLoanAmount: number;
  maxLoanAmount: number;
  isApplicationRejected: boolean;
}

export enum OfferLender {
  USAlliance = Lender.USAlliance,
  Lfcu = Lender.Lfcu,
  Quilo = Lender.Quilo,
  SeattleBank = Lender.SeattleBank,
  RizeCU = Lender.RizeCU,
  Prosper = Lender.Prosper,
}

export interface OfferDto {
  grossLoanAmount: number;
  term: number;
  rate: number;
  apr: number;
  monthlyPayment: number;
  lender: OfferLender;
  offerUrl: string;
  oneTimeFeePercentage: number;
  isBestPayment?: boolean;
  isLowestPayment?: boolean;
  isLowestRate?: boolean;
}

export interface DeclineOfferDto {
  applicationId: string;
}

export interface ConfirmOffersInformationDto {
  applicationId: string;
}

export default class AutomatedOffersApi extends HttpClient {
  public constructor() {
    super(process.env.REACT_APP_API_URL + '/automated-offers');
  }

  public async acceptOffer(acceptOfferDto: AcceptOfferRequestDto): Promise<AcceptOfferResponseDto> {
    return this.instance.post('/accept', acceptOfferDto).then((response) => response.data);
  }

  public async getOffers(offersRequestDto: OffersRequestDto): Promise<OffersResponseDto> {
    return this.instance.post('', offersRequestDto).then((response) => response.data);
  }

  public async declineOffer(declineOfferDto: DeclineOfferDto): Promise<void> {
    return this.instance.put('/decline', declineOfferDto).then((response) => response.data);
  }

  public async confirmOffersInformation(
    confirmOffersInformationDto: ConfirmOffersInformationDto,
  ): Promise<ApplicationDto> {
    return this.instance
      .put('/confirm-offers-information', confirmOffersInformationDto)
      .then((response) => response.data);
  }
}

export const hilAutomatedOffersApi = new AutomatedOffersApi();
